import api from "../../services/api";

// Helpers dos pedidos de compra (BDM-887).

export const PURCHASE_ORDER_KINDS = [
    { label: 'Produto', value: 'product' },
    { label: 'Gravação', value: 'customization' },
];

export const getKindLabel = kind =>
    PURCHASE_ORDER_KINDS.find(option => option.value === kind)?.label ?? kind;

// Keys dos status com regra no sistema; os demais são cadastrados pelo
// tenant em Configurações > Status e não disparam nada.
export const PURCHASE_ORDER_STATUS_KEYS = {
    draft: 'draft',
    sent: 'sent',
    invoiced: 'invoiced',
    canceled: 'canceled',
};

export const PURCHASE_ORDER_STATUS_RULES = {
    draft: 'Status de toda compra nova.',
    sent: 'Aplicado sozinho quando o rascunho é enviado ao fornecedor por e-mail.',
    invoiced: 'Lança a conta a pagar (com a automação ligada) e é aplicado sozinho quando as notas de entrada cobrem a compra.',
    canceled: 'Aplicado pelo botão "Cancelar compra". A compra cancelada não muda mais de status.',
};

export const isPurchaseOrderCanceled = purchaseOrder =>
    purchaseOrder?.status?.key === PURCHASE_ORDER_STATUS_KEYS.canceled;

export const getStatusLabel = purchaseOrder => purchaseOrder?.status?.name ?? '—';

// A ordem de cadastro é a ordem do fluxo: as migrations semeiam os status de
// sistema um segundo depois do outro, e os do tenant entram no fim.
export const sortStatuses = statuses =>
    [...statuses].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

export const fetchPurchaseOrderStatuses = () =>
    api.get(`/status?filters[0][type][equal]=purchase_order`)
        .then(res => sortStatuses(res.data.resources ?? []));

export const DELIVERY_TARGETS = [
    { label: 'Nossa empresa', value: 'company' },
    { label: 'Gravador', value: 'engraver' },
    { label: 'Cliente final', value: 'customer' },
];

export const getDeliveryLabel = target =>
    DELIVERY_TARGETS.find(option => option.value === target)?.label ?? target;
